import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    if (window.scrollY > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return <AnimatePresence data-id="element-119">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 p-4 z-50 md:hidden" data-id="element-120">
          <div className="bg-white rounded-sm shadow-2xl border border-gold-main/20 p-4 flex items-center justify-between gap-4" data-id="element-121">
            <div className="flex-1" data-id="element-122">
              <p className="font-playfair font-bold text-brown-dark text-sm leading-tight" data-id="element-123">
                El Arte de Crear Espacios Sagrados
              </p>
              <p className="font-lora text-gold-dark font-semibold text-lg" data-id="element-124">
                $9.99 USD
              </p>
            </div>
            <a href="https://pay.hotmart.com/R104866725J" target="_blank" rel="noopener noreferrer" className="bg-gold-main text-white font-lora font-semibold py-3 px-6 rounded-sm shadow-md active:scale-95 transition-transform whitespace-nowrap" data-id="element-125">
              Comprar
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}